import moment from 'moment'
import * as React from 'react'
import { interval } from 'rxjs'
import { share } from 'rxjs/operators'

const minuteClock$ = interval(60 * 1000).pipe(share())

interface TimestampProps {
  time: Date | number | string
}

export const Timestamp = React.memo(({ time: t }: TimestampProps) => {
  const [time, setTime] = React.useState(moment(t))
  const now = moment()

  React.useEffect(() => {
    const sub = minuteClock$.subscribe(() => {
      setTime(moment(t))
    })
    return () => {
      sub.unsubscribe()
    }
  }, [])

  let s = ''
  // 1 年前, 显示 L, YYYY年MMMD日
  if (time.year() !== now.year()) {
    s = time.format('L')
  } else {
    // 今年
    const diff = now.diff(time, 'hour', true)
    if (diff < 1) {
      // 小于1个小时, 显示：45分钟前
      s = time.fromNow()
    } else {
      // 大于等于1个小时, 显示： 今天 16:00
      s = time.calendar()
    }
  }

  return <time>{s}</time>
})
